<template>
  <div class="bank_wrap bg_white pl16 pr16 pt15 pb15 mt12">
    <h2 class="page_title ab c5a">{{ !confirm ? 'ゆうちょ銀行以外の金融機関' : '確認画面' }}</h2>
    <dl class="bank_form">
      <div class="form_list">
        <dt class="form_title ar">銀行名</dt>
        <dd class="form_contents">
          <p v-if="bankBlurError" class="caution c5a ab error">{{ bankErrorMessage }}</p>
          <span class="error ab">{{ error.bankName }}</span>
          <div v-if="!confirm" class="suggest">
            <div v-if="bankSelect || bankAccount.bank.bankId != ''" class="bank_select">
              <div class="">
                <span class="select_name c5a rb">{{ bankAccount.bank.bankName }}</span>
              </div>
              <span class="close" @click="selectBankCancel">×</span>
            </div>
            <div v-else class="">
              <input class="bank_input c5a rb" type="text" @blur="bankBlur" @input="bankInput" v-model="bankAccount.bank.bankName" :style="[bankBlurError ? {'border-bottom': '1px solid red'} : '']" name="bankAutoComplete" value="">
              <ul v-if="bankResult.length > 0" class="suggest_list">
                <li v-for="(value, index) in bankResult" @touchstart="isBankTouch = true" @click="OnBank(value)" :key="index" class="suggest_item c5a rb">{{ value.bankAutoComplete }}</li>
              </ul>
            </div>
          </div>
          <div v-else class="bank_input">{{ bankAccount.bank.bankName }}</div>
        </dd>
      </div>

      <div class="form_list">
        <dt class="form_title ar">支店名</dt>
        <dd class="form_contents">
          <p v-if="branchBlurError" class="caution c5a ab error">{{ branchErrorMessage }}</p>
          <span class="error ab">{{ error.branchName }}</span>
          <div v-if="!confirm" class="branch_suggest">
            <div v-if="branchSelect ||bankAccount.branch.branchId != ''" class="bank_select">
              <div class="">
                <span class="select_name c5a rb">{{ bankAccount.branch.branchName }}</span>
              </div>
              <span class="close" @click="selectBranchCancel">×</span>
            </div>
            <div v-else class="">
              <input class="bank_input c5a rb" type="text" @blur="branchBlur" @input="branchInput" v-model="bankAccount.branch.branchName" :style="[branchBlurError ? {'border-bottom': '1px solid red'} : '']" name="branchAutoComplete" value="">
              <ul v-if="branchResult.length > 0" class="suggest_list">
                <li v-for="(value, index) in branchResult" @touchstart="isBranchTouch = true" @click="OnBranch(value)" :key="index" class="suggest_item c5a rb">{{ value.branchName }}</li>
              </ul>
            </div>
          </div>
          <div v-if="confirm" class="bank_input">{{ bankAccount.branch.branchName }}</div>
        </dd>
      </div>

      <div class="form_list">
        <dt class="form_title ar">口座種別</dt>
        <dd class="form_contents">
          <span class="error ab">{{ error.accountType }}</span>
          <div v-if="!confirm" class="select_wrap">
            <select class="select rb" name="accountType" v-model="bankAccount.accountType">
              <option value="SAVING">普通</option>
              <option value="CHECKING">当座</option>
            </select>
          </div>
          <div v-else class="bank_input">{{ (bankAccount.accountType == 'CHECKING') ? '当座' : '普通' }}</div>
        </dd>
      </div>
      <div class="form_list">
        <dt class="form_title ar">口座番号</dt>
        <dd class="form_contents">
          <span class="error ab" v-html="error.accountNumber" ></span>
          <input v-if="!confirm" id="ttt" class="bank_input c5a rb" type="tel" maxlength="7" v-model="bankAccount.accountNumber" name="accountNumber" @keyup="keyUpHalfSizeRestriction" value="">
          <div v-else class="bank_input">{{ bankAccount.accountNumber }}</div>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
import Check from '@/model/getToken'
import Bank from '@/components/api/bank';
import VuetoComplete from 'vueto-complete';
import BranchOutComplete from 'vueto-complete';
import { mapGetters } from 'vuex';
import VueSimpleSuggest from "vue-simple-suggest";
import VueSimpleSuggestBranch from "vue-simple-suggest";
// import "vue-simple-suggest/dist/styles.css";

export default {
  components: {
    VuetoComplete,
    BranchOutComplete,
    VueSimpleSuggest,
    VueSimpleSuggestBranch
  },
  props: ['bankAccount', 'confirm', 'error', 'watchStatus'],
  data() {
    return {
      branchIsShow: true,
      items: null,
      noResultsMessage: '一致するものはありません。',
      bankList: [],
      branchList: [],
      bankResult: [],
      branchResult: [],
      bankSelect: false,
      branchSelect: false,
      isBankTouch: false,
      isBranchTouch: false,
      bankBlurError: false,
      bankErrorMessage: '金融機関名または金融機関コードを入力し候補から選択してください',
      branchBlurError: false,
      branchErrorMessage: '支店名または支店コードを入力し候補から選択してください',
    }
  },
  methods: {
    bankBlur() {
      if(this.isBankTouch) return;
      this.bankBlurError = true;
    },
    branchBlur() {
      if(this.isBranchTouch) return;
      this.branchBlurError = true;
    },
    bankInput(e) {
      this.suggestion(e.target.value);
    },
    suggestion(text) {
      // 検索結果の配列を初期化
      this.bankResult.splice(0, this.bankResult.length);
      if(text != '') {
        // 入力したテキストの大文字を小文字に返還後、全角を半角に変換
        let searchText = this.hankakuToZenkaku(this.lowerCase(text));
        for (var i = 0; i < this.bankList.length; i++) {
          // 銀行の一覧をfor文で回して文字を小文字に返還後、全角を半角に変換したものの中に入力したテキストと同じ文字列が含まれているかを判定
          if(this.hankakuToZenkaku(this.lowerCase(this.bankList[i].bankAutoComplete)).includes(searchText)) {
            // 含まれていれば検索結果用の配列に追加
            this.bankResult.push(this.bankList[i]);
          }
        }
        if(this.bankResult.length == 0) {
          this.bankResult.push({'bankAutoComplete': this.noResultsMessage })
        }
      }
    },
    branchInput(e) {
      this.suggestionBranch(e.target.value);
    },
    suggestionBranch(text) {
      this.branchResult.splice(0, this.branchResult.length);
      if(text != '') {
        // 入力したテキストの大文字を小文字に返還後、全角を半角に変換
        let searchText = this.hankakuToZenkaku(this.lowerCase(text));
        for (var i = 0; i < this.branchList.length; i++) {
          // 銀行の一覧をfor文で回して文字を小文字に返還後、全角を半角に変換したものの中に入力したテキストと同じ文字列が含まれているかを判定
          if(this.hankakuToZenkaku(this.lowerCase(this.branchList[i].branchName)).includes(searchText)) {
            // 含まれていれば検索結果用の配列に追加
            this.branchResult.push(this.branchList[i]);
          }
        }
        if(this.branchResult.length == 0) {
          this.branchResult.push({'branchName': this.noResultsMessage })
        }
      }
    },
    resetBankData() {
      this.bankAccount.bank.bankCode = '';
      this.bankAccount.bank.bankId = '';
      this.bankAccount.bank.bankName = '';
      this.bankAccount.bank.bankNameKana = '';
    },
    resetBranchData() {
      this.bankAccount.branch.branchCode = '';
      this.bankAccount.branch.branchId = '';
      this.bankAccount.branch.branchName = '';
      this.bankAccount.branch.branchNameKana = '';
      this.branchSelect = false;
    },
    selectBankCancel() {
      this.bankSelect = false;
      this.branchList.splice(0, this.branchList.length);
      this.branchResult.splice(0, this.branchResult.length);
      this.resetBankData();
    },
    selectBranchCancel() {
      this.branchSelect = false;
      this.resetBranchData();
      this.branchResult.splice(0, this.branchResult.length);
      if(this.branchList.length == 0 && this.bankAccount.bank.bankId != '') {
        this.apiGetBranchList(this.bankAccount.bank.bankId);
      }
    },
    OnBank(data) {
      if(data.bankId == null) return;
      this.bankAccount.bank.bankCode = data.bankCode;
      this.bankAccount.bank.bankId = data.bankId;
      this.bankAccount.bank.bankName = data.bankName;
      this.bankAccount.bank.bankNameKana = data.bankNameKana;

      this.bankSelect = true;
      this.bankResult.splice(0, this.bankResult.length);
      this.branchResult.splice(0, this.branchResult.length);
      this.isBankTouch = false;
      this.resetBranchData();
      this.apiGetBranchList(data.bankId);
      this.bankBlurError = false;
    },
    OnBranch(data) {
      if(data.branchId == null) return;
      this.bankAccount.branch.branchCode = data.branchCode;
      this.bankAccount.branch.branchId = data.branchId;
      this.bankAccount.branch.branchName = data.branchName;
      this.bankAccount.branch.branchNameKana = data.branchNameKana;

      this.branchSelect = true;
      this.branchResult.splice(0, this.branchResult.length);
      this.branchBlurError = false;
      this.isBranchTouch = false;
    },
    async apiGetBankList() {
      await Bank.getBankList().then((val) => {
        console.log('銀行一覧');
        console.log(val);
        for (var i = 0; i < val.bankList.length; i++) {
          val.bankList[i].bankAutoComplete = val.bankList[i].bankCode + ':' + val.bankList[i].bankName;
        }
        this.bankList.push(...val.bankList);
      });
    },
    async apiGetBranchList(bankId) {
      console.log(bankId);
      this.branchList.splice(0, this.branchList.length);
      await Bank.getBranchList(bankId).then((val) => {
        console.log('支店一覧');
        console.log(val);
        // this.$store.commit('setBankBranchList', val.bankBranchList);
        this.branchList.push(...val.bankBranchList);
      });
    },
    keyUpHalfSizeRestriction() {
      let tmp_value = this.bankAccount.accountNumber;
      if(tmp_value){
        this.bankAccount.accountNumber = tmp_value.replace(/[^0-9]/g,'');
      }
    },

    hankakuToZenkaku(str) {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },
    lowerCase(str) {
      return str.toLowerCase();
    },
  },
  computed: mapGetters(['bankBranchList', 'getBank', 'purchaseCartCount']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.apiGetBankList();
    }
  },
  watch: {
    items() {
      this.OnBank(this.items);
    }
  }
}
</script>

<style lang="css" scoped>
.form_list {margin-top: 30px;}
.form_title {
  color: #878787;
  font-size: 12px;
}
>>> .bank_input, .select {
  border: none;
  border-bottom: 1px solid  #c9c9c9;
  color: #5a5a5a;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 16px;
  margin-top: 5px;
  padding-bottom: 10px;
  width: 100%!important;
}
.form_contents {
  position: relative;
}
>>> .suggestions {
  box-shadow: 0px 0px 7px #ccc;
  position: absolute;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 100;
  border-radius: 5px;
}
>>> .suggestItem {
  padding: 10px;
  font-weight: bold;
  font-size: 16px;
}
.select_wrap {
  border-bottom: 1px solid  #c9c9c9;
  padding-bottom: 10px;
}
.select_wrap .select {
  border: none;
  padding-bottom: 0;
}
.select_wrap::after {
  right: 0;
  top: 6px;
}

.suggest {
  position: relative;
}
.suggest_list {
  background-color: #fff;
  border: 1px solid  #c9c9c9;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 100;
}
.suggest_item {
  border-bottom: 1px solid  #c9c9c9;
  font-size: 14px;
  padding: 8px;
}
.suggest_item:hover {
  background-color: #4FCCD4;
  color: #fff;
}
.bank_select {
  -ms-align-items: center;
  align-items: center;
  border: 1px solid  #f5f5f5;
  background-color: #f5f5f5;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 5px;
  padding: 8px;
}
.select_name {

}
.sub_text {
  margin-left: 5px;
}

.close {
  align-items: center;
  background-color: #ccc;
  border: 1px solid #c9c9c9;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 100%;/*ボタンの大きさ*/
  font-weight: bold;
  justify-content: center;
  width: 20px;
}

.caution {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/OtherYucho.vue